import {
    getMethod,
    postMethod,
    putMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setBlogs,
    setSelectedBlog,
    addBlog,
    updateBlog,
    removeBlog
} from "./blogSlice";

/* GET ALL */
export const fetchBlogs = () => async (dispatch) => {
    const res = await getMethod("/blog");
    if (res?.success) dispatch(setBlogs(res.data));
    return res;
};

/* GET DETAILS */
export const fetchBlogDetails = (id) => async (dispatch) => {
    const res = await getMethod(`/blog/${id}`);
    if (res?.success) dispatch(setSelectedBlog(res.data));
    return res;
};

/* CREATE */
export const createBlog = (data) => async (dispatch) => {
    const res = await postMethod("/blog", data);
    if (res?.success) dispatch(addBlog(res.data));
    return res;
};

/* UPDATE */
export const updateBlogAction = (id, data) => async (dispatch) => {
    const res = await putMethod(`/blog/${id}`, data);
    if (res?.success) dispatch(updateBlog(res.data));
    return res;
};

/* DELETE */
export const deleteBlog = (id) => async (dispatch) => {
    const res = await deleteMethod(`/blog/${id}`);
    if (res?.success) dispatch(removeBlog(id));
    return res;
};